import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useAuthStore from '../store/authStore'
import {
  buildLoginPath,
  capturePostLoginRedirect,
} from '../utils/authRedirect'

const ProtectedRoute = ({ children }) => {
  const token = useAuthStore((state) => state.token)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!token) {
      const intended = `${location.pathname}${location.search}${location.hash}`
      capturePostLoginRedirect(intended)
      navigate(buildLoginPath(intended), { replace: true })
    }
  }, [token, navigate, location.pathname, location.search, location.hash])

  if (!token) {
    return null
  }

  return children
}

export default ProtectedRoute
